// import { configureStore } from '@reduxjs/toolkit';

// import tokenReducer from './tokenSlice';

// export const store = configureStore({
//   reducer: {
//     token: tokenReducer,
//     // Include other reducers here if any
//   },
// });


// store.js



import { configureStore } from '@reduxjs/toolkit';
import sessionReducer from './sessionSlice';
import tokenReducer from './tokenSlice';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
};

const persistedReducer = persistReducer(persistConfig, sessionReducer);

export const store = configureStore({
  reducer: {
    session: persistedReducer,
    token: tokenReducer, // Add other reducers here if needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
